<template>
    <section class="custom-dashboard" v-bind:class="{ 'mobile': isMobile }">
        <div class="container">
            <MobileMenu v-if="isMobile" />

            <h1 class="page-title text-center text-base"><strong class="text-large-heading">Step 3</strong> <br><span class="text-large-sub-heading">Click and drag the value driver cards to rank from most to least important.</span></h1>

            <draggable class="grid justify-center" v-model="selectedDrivers" :move="checkPosition" :options="{animation:500}">
                <div v-for="(driver, index) in selectedDrivers" class="col-2" :class="{locked : !driver.selected}" :key="driver.name" v-show="driver.selected">
                    <div class="card card-input text-center is-selected">
                        <div class="card__body">
                            <figure><img :src="categorySvg(driver.abbreviation)"></figure>
                            <h3 class="text-large-heading" v-html="breakTitle(driver.name)"></h3>
                            <ul class="sub-drivers">
                                <li v-for="item in driver.children" :class="[item.selected ? '' : 'text-gray']">
                                    <template v-if="item.liked">
                                        <svg class="icon icon-Heart" :style="{color: getColorHex(driver.color)}"><use xlink:href="#icon-Heart"></use></svg>
                                    </template>
                                    {{item.name}}
                                </li>
                            </ul>
                            <div class="mobile-arrows" v-if="isMobile">
                                <svg @click="clickDrag(driver.name, 'up', index)" class="icon icon-Left" :class="driver.color"><use xlink:href="#icon-Left"></use></svg>
                                <svg @click="clickDrag(driver.name, 'down', index)" class="icon icon-Right" :class="driver.color"><use xlink:href="#icon-Right"></use></svg>
                            </div>
                        </div>
                        <span class="circle-button" :class="driver.color">{{index+1}}</span>
                    </div>
                </div>
            </draggable>
        </div>

    </section>
</template>

<script>
    import router from '../router.js';
    import EventBus from '../eventbus.js';
    import Draggable from 'vuedraggable';
    import MobileMenu from './../components/MobileMenu';

    export default {
        data : function() {
            return {
                isMobile: false,
                selectedDrivers: []
            }
        },
        created() {
            // if ( this.selectedDrivers.length == 0) {
            //     router.push({ name: "selectDrivers"});
            // }
            this.isMobile = this.$store.getters.isMobile;
            const self = this;

            window.addEventListener('resize', function() {
                if ( window.innerWidth < self.$store.getters.mobileWidth ) {
                    self.isMobile = true;
                } else {
                    self.isMobile = false;
                }
            });
        },
        computed: {
            drivers: {
                get() {
                    return this.$store.getters.drivers;
                },
                set(value) {
                    this.$store.commit('updateDrivers', value);
                }
            }
        },
        watch: {
            selectedDrivers(value) {
                for (var i = 0; i < this.selectedDrivers.length; i++) {
                    this.selectedDrivers[i].order = i + 1;
                }

                this.$store.commit('updateDrivers', this.selectedDrivers);
            }
        },
        mounted() {
            EventBus.$emit('updateBottomNav');
            EventBus.$emit('nav.updateAction', 'button');
            EventBus.$emit('nav.updateLink', this.$route.meta.buttonLink);

            //get all drivers
            let drivers = this.$store.getters.drivers;


            //filter only the selected drivers
            let selectedDrivers   = drivers.filter( function(driver){
                return driver.selected;
            });

            //filter the unselected drivers
            let unSelectedDrivers = drivers.filter( function(driver){
                return !driver.selected;
            });

            //sort the selected drivers
            selectedDrivers.sort(function(a,b){
                //if the driver has zero likes,
                //sort by the number of selected sub drivers
                if ( a.likes === 0 || a.likes === b.likes ) {
                    return a.selected_drivers > b.selected_drivers;
                }

                //otherwise sort by the number of likes
                return a.likes > b.likes;
            });

            //reverse the order to display properly
            selectedDrivers.reverse();

            //sort the children
            for (var i = 0; i < selectedDrivers.length; i++) {
                selectedDrivers[i].children.sort(function(a,b){
                    //if an item is liked
                    //show those first
                    if ( a.liked ) {
                        return a.liked > b.liked;
                    }

                    //otherwise sort by if the item is
                    //selected or not
                    return a.selected > b.selected;
                });

                //reverse the order for display purposes
                selectedDrivers[i].children.reverse();
            }

            //add the unselected drivers to the end of our selected drivers
            //and dump them both into the components sortable driver list.
            //This list is used to drag and drop and determine the final
            //order of the portal view. Unselected ones are hidden,
            //and will always display at the end.
            this.selectedDrivers = selectedDrivers.concat(unSelectedDrivers);
        },
        methods : {
            getColor( category ) {
                let color = window.getCategoryColor( category );
                return 'is-' + color;
            },
            getColorHex(color) {
                let colorName = color.split('-');
                return this.$store.getters.colors[colorName[1]];
            },
            categorySvg( category ) {
                return '/'+category + '-icon.svg';
            },
            breakTitle: function(title) {
                title = title.split(' ');
                return title[0] + '<br>' + title[title.length - 1];
            },
            checkPosition(event) {
                //when dragging an item if the one it's replacing is locked
                //don't move it. This lets us keep the hidden items at the end
                //of the list
                if (event.related)
                {
                    return !event.related.classList.contains('locked');
                }
            },
            // resortDrivers(initDriverSort, direction, driverPos, driverName) {

            // },
            clickDrag(driverName, direction, itemPos) {
                console.log(itemPos);
                let initArr = this.selectedDrivers,
                    visCardLength = 0;
                
                // guards
                if ( itemPos === 0 && direction === 'up' ) {
                    return;
                }

                initArr.map(function(driver) {
                    if ( driver.selected ) {
                        visCardLength += 1;
                    }
                });

                console.log(visCardLength);
                
                if ( itemPos === visCardLength -1 && direction === 'down' ) {
                    return;
                }
                
                let replaceItemId = -1,
                    originalUp = driverName,
                    originalDown = '',
                    self = this;
                    
                if ( direction === 'up' ) {
                    replaceItemId = itemPos - 1;
                    originalDown = initArr[replaceItemId].name;
                    $("h3:contains('" + originalUp.replace(' ', '') + "')").closest('.col-2').addClass('slide-up');
                    $("h3:contains('" + originalDown.replace(' ', '') + "')").closest('.col-2').addClass('slide-down');
                }

                if ( direction === 'down' ) {
                    replaceItemId = itemPos + 1;
                    originalDown = initArr[replaceItemId].name;
                    $("h3:contains('" + originalUp.replace(' ', '') + "')").closest('.col-2').addClass('slide-down');
                    $("h3:contains('" + originalDown.replace(' ', '') + "')").closest('.col-2').addClass('slide-up');
                }

                setTimeout( function() {
                    $('.col-2').removeClass('slide-up');
                    $('.col-2').removeClass('slide-down');

                    let replaceItemVal = initArr[replaceItemId],
                        replaceWithItemVal = initArr[itemPos];

                    initArr.splice(itemPos, 1);
                    initArr.splice(replaceItemId, 0, replaceWithItemVal);

                    setTimeout(function() {
                        self.selectedDrivers = initArr;
                        self.$store.commit('updateDrivers', initArr);
                    }, 300);
                }, 300);
            }
        },
        components: {
            Draggable,
            MobileMenu
        },
    }
</script>

<style lang="css" scoped>
    .card-input {
        height: 100%;
    }

    .card-input.is-selected .circle-button {
        transform: translate(-50%,50%);
    }

    .col-2 {
        width: 20%;
    }

    .custom-dashboard.mobile .container {
        padding-left: 1em;
        padding-right: 1em;
    }

    .custom-dashboard.mobile .page-title {
        margin-bottom: 0;
        margin-top: 4em;
    }

    .custom-dashboard.mobile .col-2 {
        width: 375px;
    }

    .custom-dashboard.mobile .col-2.slide-up {
        transform: translateY(-110px);
        transition: all 0.1s ease-in-out;
        /* opacity: 0.8; */
    }

    .custom-dashboard.mobile .col-2.slide-down {
        transform: translateY(110px);
        transition: all 0.3s ease-in-out;
        /* opacity: 0.8; */
    }

    .custom-dashboard.mobile .grid:last-of-type {
        margin-bottom: 8em;
    }

    @media screen and (max-width: 480px) {
        .custom-dashboard.mobile .col-2 {
            width: 90%;
        }
    }

    .custom-dashboard.mobile .sub-drivers {
        display: none;
    }

    .custom-dashboard.mobile .text-large-heading {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .custom-dashboard.mobile .mobile-arrows {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        flex: 1 0 auto;
    }

    .custom-dashboard.mobile .icon-Left, .custom-dashboard.mobile .icon-Right {
        font-size: 1.75em;
    }

    .custom-dashboard.mobile .icon-Left:hover, .custom-dashboard.mobile .icon-Right:hover {
        color: white;
    }

    .custom-dashboard.mobile .icon-Left:active, .custom-dashboard.mobile .icon-Right:active  {
        color: white;
    }

    .custom-dashboard.mobile .icon-Left {
        transform: rotate(90deg);
    }

    .custom-dashboard.mobile .icon-Right {
        transform: rotate(90deg);
        margin-top: 1em;
    }

    /* responsive mobile */

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/StepThree.vue